module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? _c('div', {
    staticClass: "margin-bottom-10"
  }, [(!_vm.forms.hasOwnProperty('profile')) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addForm('profile')
      }
    }
  }, [_vm._v("\n      Add Profile Form\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.forms.hasOwnProperty('assignment')) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addForm('assignment')
      }
    }
  }, [_vm._v("Add Status Form\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.forms.hasOwnProperty('contact')) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addForm('contact')
      }
    }
  }, [_vm._v("\n      Add Contact Form\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('base-form-index', {
    attrs: {
      "loading": _vm.loading,
      "rows": _vm.rows,
      "columns": _vm.columns
    },
    on: {
      "form-removed": _vm.fetchSystemForms
    }
  }), _vm._v(" "), (_vm.showAddFormModal) ? _c('add-form-modal', {
    attrs: {
      "modules": _vm.modules,
      "preselected-module": _vm.preselectedModule,
      "lock-module-select": true
    },
    on: {
      "hide": function($event) {
        _vm.showAddFormModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ae92e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/indexes/SystemFormsIndex.vue
// module id = 1621
// module chunks = 1